<div class="container">
  <mat-card appearance="outlined">
    <h2>Please Verify Your Email Address</h2>

    @if (emailVerificationResponse(); as response) {
      <p>{{ response.message }}</p>
    } @else {
      <p>
        We have sent you an email confirmation. Please click the link in the
        email to verify your email address.
      </p>
    }

    @if (!emailVerificationResponse()?.success) {
      <button
        mat-flat-button
        color="primary"
        [disabled]="emailVerificationResponse()?.success || sending()"
        (click)="emailVerificationRequest$.next()"
      >
        @if (!sending()) {
          {{
            emailVerificationResponse()?.success
              ? "Email Sent"
              : "Resend Verification Email"
          }}
        } @else {
          <mat-spinner
            color="primary"
            value="100"
            mode="indeterminate"
            style="margin-left: auto; margin-right: auto"
            diameter="20"
            strokeWidth="2"
          >
          </mat-spinner>
        }
      </button>
    }
  </mat-card>
</div>
